import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@solum/ui/global.css'
import './brand.css'
import { App } from './app'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
